// extracted by mini-css-extract-plugin
export default {"highlightRow":"AssignValuesTable_highlightRow__1X0bc"};